import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { cachedSerialNames31jc5fovi62px as cachedSerialNames } from './Platform.common.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from '../descriptors/SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from './CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var NullableSerializerClass;
function NullableSerializer() {
  if (NullableSerializerClass === VOID) {
    class $ {
      constructor(serializer) {
        this.n1z_1 = serializer;
        this.o1z_1 = new (SerialDescriptorForNullable())(this.n1z_1.g1m());
      }
      g1m() {
        return this.o1z_1;
      }
      p1z(encoder, value) {
        if (!(value == null)) {
          encoder.t1s();
          encoder.q1s(this.n1z_1, value);
        } else {
          encoder.t1r();
        }
      }
      h1m(encoder, value) {
        return this.p1z(encoder, value);
      }
      i1m(decoder) {
        return decoder.i1q() ? decoder.w1q(this.n1z_1) : decoder.j1q();
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof NullableSerializer()))
          THROW_CCE();
        if (!equals(this.n1z_1, other.n1z_1))
          return false;
        return true;
      }
      hashCode() {
        return hashCode(this.n1z_1);
      }
    }
    initMetadataForClass($, 'NullableSerializer', VOID, VOID, [KSerializer()]);
    NullableSerializerClass = $;
  }
  return NullableSerializerClass;
}
var SerialDescriptorForNullableClass;
function SerialDescriptorForNullable() {
  if (SerialDescriptorForNullableClass === VOID) {
    class $ {
      constructor(original) {
        this.w1o_1 = original;
        this.x1o_1 = this.w1o_1.j1n() + '?';
        this.y1o_1 = cachedSerialNames(this.w1o_1);
      }
      j1n() {
        return this.x1o_1;
      }
      g1q() {
        return this.y1o_1;
      }
      v1o() {
        return true;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SerialDescriptorForNullable()))
          return false;
        if (!equals(this.w1o_1, other.w1o_1))
          return false;
        return true;
      }
      toString() {
        return toString(this.w1o_1) + '?';
      }
      hashCode() {
        return imul(hashCode(this.w1o_1), 31);
      }
      c1p() {
        return this.w1o_1.c1p();
      }
      d1p() {
        return this.w1o_1.d1p();
      }
      e1p() {
        return this.w1o_1.e1p();
      }
      f1p() {
        return this.w1o_1.f1p();
      }
      g1p(index) {
        return this.w1o_1.g1p(index);
      }
      h1p(name) {
        return this.w1o_1.h1p(name);
      }
      i1p(index) {
        return this.w1o_1.i1p(index);
      }
      j1p(index) {
        return this.w1o_1.j1p(index);
      }
      k1p(index) {
        return this.w1o_1.k1p(index);
      }
    }
    initMetadataForClass($, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorForNullableClass = $;
  }
  return SerialDescriptorForNullableClass;
}
//region block: exports
export {
  NullableSerializer as NullableSerializer41etqlj0tdq5,
  SerialDescriptorForNullable as SerialDescriptorForNullable2slcv65za9oog,
};
//endregion

//# sourceMappingURL=NullableSerializer.mjs.map
